import { css, keyframes } from 'styled-components';
import { colors } from './colors';
export const sizeToPixel = {
    none: '0px',
    xs: '4px',
    s: '8px',
    m: '12px',
    l: '16px',
    xl: '24px',
    '2xl': '48px',
    '3xl': '56px',
    '4xl': '72px',
    '5xl': '120px',
};
export const getSize = (size) => {
    if (size in sizeToPixel)
        return sizeToPixel[size];
    return size;
};
export var Breakpoints;
(function (Breakpoints) {
    Breakpoints["Min"] = "320px";
    Breakpoints["Mobile"] = "600px";
    Breakpoints["Tablet"] = "905px";
    Breakpoints["Desktop"] = "";
    Breakpoints["Application"] = "834px";
})(Breakpoints || (Breakpoints = {}));
export var BreakpointsPx;
(function (BreakpointsPx) {
    BreakpointsPx[BreakpointsPx["Min"] = 320] = "Min";
    BreakpointsPx[BreakpointsPx["Mobile"] = 600] = "Mobile";
    BreakpointsPx[BreakpointsPx["Tablet"] = 905] = "Tablet";
    BreakpointsPx[BreakpointsPx["Desktop"] = 0] = "Desktop";
    BreakpointsPx[BreakpointsPx["Application"] = 834] = "Application";
})(BreakpointsPx || (BreakpointsPx = {}));
export var MaxWidth;
(function (MaxWidth) {
    MaxWidth["Input"] = "400px";
    MaxWidth["Button"] = "400px";
    MaxWidth["Content"] = "600px";
    MaxWidth["Container"] = "1200px";
})(MaxWidth || (MaxWidth = {}));
export const ANIMATION_DURATION_MS = 100;
export const ANIMATION_DURATION = `${ANIMATION_DURATION_MS}ms`;
export const ACCORDION_ANIMATION_DURATION_MS = 300;
export const ACCORDION_ANIMATION_DURATION = `${ACCORDION_ANIMATION_DURATION_MS}ms`;
export const BUTTON_WIDTH = `min(100%, ${MaxWidth.Button})`;
export const shimmerEffect = keyframes `
0% {
  background-position: -100vw 0;
}

100% {
  background-position: 100vw 0; 
}
`;
export const shimmerCSS = css `
  color: transparent;
  background: #f6f7f8;
  background-image: linear-gradient(
    to right,
    #f6f7f8 0%,
    #edeef1 20%,
    #f6f7f8 40%,
    #f6f7f8 100%
  );
  background-repeat: no-repeat;
  background-size: 100vw 100vw;
  display: inline-block;
  position: relative;

  animation: ${shimmerEffect} 2s linear infinite;
`;
export const fadeIn = keyframes `from { opacity: 0; } to { opacity: 1; }`;
export const fadeOut = keyframes `from { opacity: 1; } to { opacity: 0; }`;
export const progressBarConfig = {
    circleSize: '24px',
    circleBorderRadius: '12px',
    connectorHeight: '1px',
    completeBackgroundColor: 'var(--merchant-color)',
    incompleteBackgroundColor: colors.background.backgroundDisabled,
    completeColor: 'white',
    incompleteColor: colors.content.onBackground,
    circleSizeSubstep: '8px',
};
export const borderRadius = {
    xs: '4px',
    s: '8px',
    m: '12px',
    l: '16px',
    xl: '24px',
};
export const spacing = {
    xxs: '2px',
    xs: '4px',
    s: '8px',
    m: '12px',
    l: '16px',
    xl: '24px',
};
//# sourceMappingURL=design-system.js.map